import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (startDate, endDate) => `${API_URL}/api/v1/admin/report/interactions-to-sell?startDate=${startDate}&endDate=${endDate}`;

const getInteractionsToSell = async (startDate, endDate) => await apiRequest(getUrl(startDate, endDate), "get");

export default getInteractionsToSell;
